/**
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import type { ModalProps } from '../modal';

export interface DialogBaseProps {
  /** The content to display within the dialog component. */
  children?: React.ReactNode;
}

// Should extend ModalCloseReason
export enum DialogCloseReason {
  ESCAPE_KEY_DOWN = 'escapeKeyDown',
  CLOSE_BUTTON_CLICK = 'closeButtonClick',
}

export interface DialogProps extends Omit<ModalProps, 'onClose'> {
  /** Controls whether the dialog is open or closed. */
  isOpen: boolean;
  /** Type of dialog, which determines the icon and styling. */
  variant?: 'info' | 'warning' | 'danger';
  /** Whether to disable the close button in the top-right corner. */
  hasDisabledCloseButton?: boolean;
  /** Callback function called when the dialog is closed. */
  onClose?: (
    e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement>,
    reason?: DialogCloseReason,
  ) => void;
}

export interface DialogContextType {
  headerId?: string;
  setHeaderId?: (id: string) => void;
  variant?: DialogProps['variant'];
}

export type DialogActionsProps = DialogBaseProps;

export type DialogHeaderProps = DialogBaseProps;

export type DialogSubtitleProps = DialogBaseProps;

export type DialogDescriptionProps = DialogBaseProps;

export type DialogContentProps = DialogBaseProps;

export type DialogImageProps = {
  /** Source URL of the image */
  src: string;
  /** Alternative text for the image */
  alt: string;
};
